/**
 * Токен экрана в localStorage: планшет в киоске не должен спрашивать код после
 * каждой перезагрузки. Тот же приём, что у LAN-страницы (там хранится PIN).
 */
const KEY = 'tracker_token'

export function readToken(): string | null {
  try {
    return localStorage.getItem(KEY)
  } catch {
    // Приватный режим/заблокированное хранилище — работаем как непривязанные.
    return null
  }
}

export function writeToken(token: string): void {
  try {
    localStorage.setItem(KEY, token)
  } catch {
    /* не смогли сохранить — экран попросит код после перезагрузки */
  }
}

export function clearToken(): void {
  try {
    localStorage.removeItem(KEY)
  } catch {
    /* игнорируем */
  }
}
